<template>
    <div class="occupation">
        <tab></tab>
        <!-- <div style="width:1200px;margin:0 auto;height:82px;line-height:82px;font-size:15px;">当前位置：首页>职业技能类>详情</div> -->
        <!-- 分类按钮 -->
        <!-- <div class="sort">
            <div :class="btnColor == index ?classA:classB" @click="btnFn(index,item.courseId)" v-for="(item, index) in btnList" :key='index'>{{item.courseName}}</div> -->

            <!-- <div style="float:left;margin-left:32px;margin-right:14px;font-weight:bold;">管理课程</div>
            <div class="select" style="width:200px;float:left;">
                <Select v-model="value" style="width:200px">
                    <Option v-for="item in options" :value="item.value" :key="item.value">{{ item.label }}</Option>
                </Select>
                
            </div> -->
            <!-- <div class="search">
                <input type="text" placeholder="请输入关键字">
                <img src="../../static/videoclass/search.png" alt="">
            </div>
        </div> -->

        <div class="introduce">
            <div class="introduce-l">
                <img :src="data.coverUrl" alt="">
            </div>
            <div class="introduce-r">
                <div style="font-size:22px;font-weight:bold;margin-top:30px;margin-bottom:24px;">{{data.name}}</div>
                <div style="">{{data.remark}}</div>
                <div style="margin-top:64px;margin-bottom:90px;">
                    <span>{{data.institutionName}}</span>
                    <span>|</span>
                    <span>{{data.catalogueSize}}节课程</span>
                </div>
                <div class="introduce-r-btn">
                    <div @click="addAll()">全部添加</div>
                    <div @click="collectFn()">收藏</div>
                </div>
            </div>
        </div>
        
        <div class="catalog">
            <div style="width:100%;height:48px;border-bottom:1px solid #edefee;margin-bottom:22px;">
                <div style="font-weight:bold;width:74px;text-align:center;height:47px;line-height:47px;border-bottom:2px solid #0ca8e1;margin-left:33px;">
                    课程目录
                </div>
            </div>

            <div class="catalog-i" v-for="(item, index) in courseList" :key='index'>
                <div class="catalog-i-t">
                    {{item.catalogueName}}
                     <div class="addcourse" @click="addCourse(item.catalogueId)">
                         添加课程
                     </div>
                     <div class="lookpdf" @click="lookPdf(item.pdfUrl)">
                         查看资料
                     </div>
                </div>
                <div class="catalog-i-v" v-for="(itemson, index) in item.videoList" :key='index' @click="toPlayer(itemson.videoNo,item.catalogueId)">
                    {{itemson.name}}
                    <img src="../../static/videoclass/eye.jpg" alt="">
                </div>
                
            </div>

           
        </div>
        <div style="width:100%;height:90px;"></div>
    </div>
</template>

<script>
    import { MessageBox } from 'element-ui'
    import tab from '../common/tab.vue'
    
    export default {
        name: "videolist",
        components:{
            tab
        },
        data () {
            return {
                picUrl:[],
                btnColor:0,
                classA:'classA',
                classB:'classB',
                options: [{
                    value: '选项1',
                    label: '黄金糕'
                    },  {
                    value: '选项4',
                    label: '龙须面'
                    }, {
                    value: '选项5',
                    label: '北京烤鸭'
                }],
                value: '',
                data:'', //二级首页 课堂介绍list数据
                courseList:[],
                btnList:[], //分类按钮列表
                courseId:0,  //课程id
            };
        },
        methods: {
            btnFn(s,id){
                this.btnColor = s;

                this.courseId = id;
                //分类按钮，教师列表页
                this.$axios.post("/v1/muke/student/course/selectCourseDetailed",{
                    courseId:id
                })
                .then(({data})=>{
                    if(data.code == 200){
                        this.courseList = data.data.catalogueVoList;
                        // data.data.catalogueVoList
                    }
                   
                })
                // × 接口修改
                // this.$axios.post("/v1/muke/student/course/selectCourseDetailByCatalogue",{
                //     catalogueId:s,
                // }).then(({data})=>{
                //     console.log("分类按钮数据",data);
                // })
            },
            toPlayer(code,id){
                sessionStorage.setItem('tabIndex',0);
                this.$router.push({
                    path: '/courseplayer',
                    query: {
                        code,
                        id,
                    }
                })
            },
            addAll(){
                if(localStorage.token){
                    this.$axios.post("/v1/muke/student/course/insertMyCourse",{
                        courseId:this.courseId
                    })
                    .then(({data})=>{
                        if(data.data){
                            this.$Message.success('添加成功！');
                        }else{
                            this.$Message.error('添加失败！');
                        }
                        
                    })
                }else{
                    this.open();
                }
            },
            collectFn(){
                if(localStorage.token){
                    this.$axios.post("/v1/muke/student/course/insertCourseCollection",{
                        courseId:this.courseId
                    })
                    .then(({data})=>{
                        if(data.data){
                            this.$Message.success('收藏成功！');
                        }else{
                            this.$Message.error('收藏失败！');
                        }
                        
                    })
                }else{
                    this.open();
                }
            },
            addCourse(id){
                if(localStorage.token){
                    this.$axios.post("/v1/muke/student/course/insertMyCourse",{
                        courseId:this.courseId,
                        catalogueIds:id,
                    })
                    .then(({data})=>{
                        if(data.data){
                            this.$Message.success('添加成功！');
                        }else{
                            this.$Message.error('添加失败！');
                        }
                        
                    })
                }else{
                    this.open();
                }
                
            },
            open(){
                MessageBox.confirm('', '您还没有登录哦，去登录一下吧', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    center: true
                    }).then(() => {
                        this.$router.push({name:'login'})
                    }).catch(() => {

                    });
            },  
            lookPdf(url){
                // http://q8v3ft64j.bkt.clouddn.com/更多.pdf
                window.open(url,'_blank'); 
            }
        },
        created(){
            let courseId = this.$route.query.courseId;
            if(courseId){
                let catalogueId = 1;
                //课程列表页
                this.$axios.post("/v1/muke/student/course/selectCourseDetailed",{
                    courseId,
                }).then(({data})=>{
                    if(data.code == 200){
                        this.data = data.data;
                        this.btnList = data.data.courseVoList;
                        this.courseList = data.data.catalogueVoList;
                        this.courseId = data.data.courseVoList[0].courseId;
                    }
                })
            }
            
        },
        mounted(){
            // this.$axios.post("/v1/muke/student/course/selectCourseDetailed",{
            //     courseId:1,
            // }).then(({data})=>{
            //     console.log("二级首页 课程介绍",data);
            // })
        }
    }
</script>

<style scoped lang="less">
    .occupation{
         -webkit-touch-callout: none; /* iOS Safari */
        -webkit-user-select: none; /* Chrome/Safari/Opera */
        -khtml-user-select: none; /* Konqueror */
        -moz-user-select: none; /* Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
        user-select: none;

        width:100%;
        background:#f7f7f7;
        // margin:0 auto;
        .sort{
            width:1200px;
            height:66px;
            line-height: 66px;
            margin:0 auto;
            background:white;
            .classA{
                background:#f2981e;
                color:white;
                border:1px solid rgba(0,0,0,0);
                float: left;
                cursor: pointer;
                // width:64px;
                padding:0 10px;
                height:26px;
                line-height: 26px;
                text-align:center;
                margin-top:22px;
                margin-left:24px;
            }
            .classB{
                border:1px solid #d2d2d2;
                float: left;
                cursor: pointer;
                // width:64px;
                padding:0 10px;
                height:26px;
                line-height: 26px;
                text-align:center;
                margin-top:22px;
                margin-left:24px;
            }
            .search{
                float:right;
                width:316px;
                height:36px;
                border:1px solid #d2d2d2;
                margin-top:15px;
                margin-right:19px;
                img{
                    display: block;
                    width:24px;
                    height:19px;
                    float:right;
                    margin-top:7px;
                    margin-right:12px;
                }
                input{
                    height:36px;
                    float:left;
                    width:254px;
                    margin-left:10px;
                }
            }
        }
        .introduce{
            width:1200px;
            height:380px;
            overflow: hidden;
            margin:0 auto;margin-top:40px;margin-bottom:40px;   
            .introduce-l{
                float:left;
                width:780px;
                height:380px;
                img{display: block;width:100%;height:100%;}
            }
            .introduce-r{
                float:right;
                width:374px;
                height:380px;
                .introduce-r-btn div:nth-of-type(1){
                    cursor: pointer;
                    float: left;
                    width:88px;
                    height:26px;
                    line-height: 26px;
                    text-align: center;
                    border:1px solid rgba(0,0,0,0);
                    background:#f29820;
                    color:white;
                }
                .introduce-r-btn div:nth-of-type(2){
                    cursor: pointer;
                    float: left;
                    width:88px;
                    height:26px;
                    line-height: 26px;
                    text-align: center;
                    margin-left:12px;
                    border:1px solid #d2d2d2;
                }
            }
        }
        .catalog{
            width:1200px;
            margin:0 auto;
            overflow: hidden;
            background:white;
            // padding:0 34px;
            border:1px solid #edefee;
            padding-bottom:28px;
            margin-bottom:60px;
            .catalog-i{
                border:1px solid #e5e5e5;border-bottom: none;
                margin:0 32px;margin-bottom:10px;
                .catalog-i-t{
                    width:100%;height:40px;line-height:40px;background:#e5e5e5;padding-left:19px;
                    .addcourse{
                        float:right;width:88px;height:26px;line-height:26px;text-align:center;background:#f2981e;cursor: pointer;
                        padding:0px;color:white;font-size:14px;margin-top:7px;margin-right:31px;    
                    }
                    .lookpdf{
                        float:right;width:88px;height:26px;line-height:26px;text-align:center;background:#f2981e;cursor: pointer;
                        padding:0px;color:white;font-size:14px;margin-top:7px;margin-right:31px;
                    }
                }
                .catalog-i-v{
                    width:100%;height:40px;line-height:40px;
                    padding-left:21px;border-bottom:1px solid #e5e5e5;
                    img{
                        display: block;float:right;width:37px;height:21px;
                        margin-top:10px;margin-right:54px;display: none;
                    }
                }
                .catalog-i-v:hover img{
                    display: block;
                }
                // .catalog-i-v:nth-of-type(4){
                //     border:none;
                    
                // }
            }
        }
    }
</style>
